/**
 * Clamps a number within a min and max range.
 *
 * @param {[number, number]} [min, max] - Tuple containing the minimum and maximum values.
 * @param {number} value - The number to clamp.
 * @returns {number} The clamped value between min and max.
 */
export const clamp = ([min, max]: [number, number], value: number): number => {
  return Math.min(max, Math.max(min, value));
};
